import { Box, Skeleton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { memo } from 'react';
import useDashboardQueryFetch from '../../../../../hooks/useDashboardQueryFetch';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import useStyles from '../styles';

const useLocalStyles = makeStyles(() => ({
  text: {
    display: '-webkit-box',
    fontFamily: 'Lato',
    fontSize: '0.9rem',
    fontWeight: 500,
    color: theme.colors.neutral['700'],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
}));

const CompanyQueryCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
  const classes = useStyles();
  const localClasses = useLocalStyles();
  const { query: company, queryLoaded: companyLoaded } = useDashboardQueryFetch<string>(dashboard.id, 'Company');

  if (!companyLoaded) {
    return (
      <Box sx={{ width: '100%' }}>
        <Skeleton animation="wave" className={classes.wave} />
      </Box>
    );
  }

  if (!company || company === 'N/A') {
    return (
      <Typography className={classes.plainText} fontWeight={500} color={`${theme.colors.neutral['500']} !important`}>
        {'—'}
      </Typography>
    );
  }

  return (
    <Typography className={localClasses.text}>
      {company}
    </Typography>
  );
};

export default memo(CompanyQueryCell);
